var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{ref:"selection",attrs:{"border":"","loading":_vm.loading,"columns":_vm.insideColumns,"data":_vm.insideTableData},on:{"on-select":_vm.handleSelect,"on-select-all":_vm.handleSelectAll,"on-selection-change":_vm.handleSelectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }